import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';
import Reveal from '../../reveal';
import RevealSlideDown from '../../animations/reveal-slide-down';
import ProjectBlurb from '../project-blurb';
import styles from './project-mobile.module.css';

const ProjectMobileStagger = props => {
  return (
    <Reveal>
      <RevealSlideDown isInView={props.isInView}>
        <ProjectMobileContent {...props} />
      </RevealSlideDown>
    </Reveal>
  );
};

const ProjectMobileContent = props => {
  const { mobileImages, blurb, wrapperPadding, animation, isInView } = props;

  const mobileImageDelays = mobileImages.map((value, index) => {
    return { delay: 450 * (index + 1) };
  });

  const renderMobileImages = () => {
    return mobileImages.map((device, index) => {
      const animationConfig = {
        delay: mobileImageDelays[index].delay,
        duration: 1000,
        easing: easings.easeCubicOut,
      };
      return (
        <Spring
          key={index}
          from={{ opacity: '0' }}
          to={{
            opacity: isInView ? '1' : '0',
          }}
          config={animationConfig}
        >
          {phoneAnimation => (
            <div
              className={styles.outerWrapper}
              style={{ opacity: phoneAnimation.opacity }}
            >
              <Img
                key={index}
                backgroundColor={true}
                sizes={device.image.localFile.childImageSharp.sizes}
                className={styles.deviceImage}
                alt={'Mobile'}
              />
            </div>
          )}
        </Spring>
      );
    });
  };

  return (
    <div
      className={styles.wrapper}
      style={{
        padding: wrapperPadding,
        opacity: animation.opacity,
        transform: animation.transform,
      }}
    >
      <div className={styles.deviceWrapper}>{renderMobileImages()}</div>
      <ProjectBlurb blurb={blurb} />
    </div>
  );
};

ProjectMobileContent.propTypes = {
  mobileImages: PropTypes.array,
  blurb: PropTypes.string,
  wrapperPadding: PropTypes.string,
  animation: PropTypes.object,
  isInView: PropTypes.bool,
};

export default ProjectMobileStagger;



// WEBPACK FOOTER //
// ./src/components/project/project-mobile-stagger/index.js